import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Avatar, Tooltip, Pagination } from 'antd';
import moment from 'moment';

import { isNullOrEmpty } from '~/helpers/util';

import { taskCommentIndexRequest, taskCommentDeleteRequest } from '~/store/modules/taskComment/actions';

import { Container } from './styles';
import { DataList, Button } from '~/pages/Task/Update/styles';

export default function TaskComent({ projectId, taskId, users }) {
  const dispatch = useDispatch();

  const profile = useSelector(store => store.auth.profile);
  const commentsLoading = useSelector(store => store.taskComment.loading);
  const comments = useSelector(store => store.taskComment.list);
  const commentsCount = useSelector(store => store.taskComment.count);
  const commentsPageIndex = useSelector(store => store.taskComment.page);

  const [pagination, setPagination] = useState({ page: 1, size: 10, count: 0 });

  function onPagination(pageNumber, pageSize) {
    setPagination(prevPagination => ({
      ...prevPagination,
      page: pageNumber,
      size: pageSize
    }));
  }

  useMemo(() => {
    setPagination(prevPagination => ({
      ...prevPagination,
      count: commentsCount,
      page: !commentsPageIndex ? 1 : commentsPageIndex
    }));
  }, [comments]);

  useMemo(() => {
    let filters = [{ page: pagination.page }, { pageSize: pagination.size }];

    if (!isNullOrEmpty(taskId) && !isNullOrEmpty(projectId)) {
      dispatch(taskCommentIndexRequest(projectId, taskId, filters));
    }
  }, [pagination.page, pagination.size, taskId]);

  return (
    <Container>
      <DataList dataSource={comments} loading={commentsLoading} pagination={false}>
        <DataList.Column align="left" dataIndex="id" key="id" render={(_, record) => {
          let commentUser = users.find(u => u.id === record.userId);

          if (!commentUser) commentUser = users.find(u => u.id === undefined);

          return (
            <Row>
              <Col xs={3} md={2}>
                <Tooltip title={commentUser.name}>
                  <Avatar size="18" icon={commentUser.icon} style={{ backgroundColor: commentUser.color, verticalAlign: 'middle' }}>
                    {commentUser.short}
                  </Avatar>
                </Tooltip>
              </Col>
              <Col xs={15} md={18}>
                <span className='commentary-content' dangerouslySetInnerHTML={{ __html: record.comment.replace(/(?:\r\n|\r|\n)/g, '<br/>') }}></span>
              </Col>
              <Col xs={6} md={4} style={{ textAlign: 'right' }}>
                {moment(record.createdAt).format('DD/MM/YYYY HH:mm')}

                {record.userId === profile.id && (
                  <>
                    <br />
                    <Button htmlType='button' type="primary" danger
                      onClick={() => { if (window.confirm('Deseja realmente excluir este comentário?')) { dispatch(taskCommentDeleteRequest(projectId, taskId, record.id)) } }}
                    >Excluir</Button>
                  </>
                )}
              </Col>
            </Row>
          );
        }} />
      </DataList>

      {commentsCount > 0 && (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Pagination current={pagination.page} pageSize={pagination.size} total={pagination.count} onChange={onPagination} />
        </div>
      )}
    </Container>
  );
}